import { base, utils } from '@mc/redux';
import { Action } from 'redux';
// Počáteční definice aplikačního store
const initialState = {
    ...base.BaseReducer(),   // APP BASE
};

export interface AppStoreAction extends Action {
    area: string;
}

/**
 * Hlavní store aplikace.
 */
export default function app(state = initialState, action: AppStoreAction) {
    if (action.area) {
        // Pokud se jedná o areu auth a akce je a o akci login, otestujeme, zda se přihlásil stejný uživatel nebo jiný, v případě jiného mažeme aplikační store

        // TODO budeme řešit resetem store - bude provided funkce v @mc/redux
        /*if (action.area === authActions.AUTH_INFO_AREA && action.type === authActions.AUTH_LOGIN) {
            const prev = action.prevAuthInfo;
            const next = action.nextAuthInfo;
            if (prev.fetched && prev.data.login !== next.data.login) {  // jiný uživatel
                // Budeme vycházet z initial state
                return utils.processAreaStores(initialState, action);
            }
        }*/

        return utils.processAreaStores(state, action);
    }

    return state;
}
